import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { ISearchResult } from '../_types/search';
import { Button, Grid } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import UserCredentials from '../common/Credentials/Credentials';
import { Typography } from '@material-ui/core';
import { IObjectPolicy, IPolicyObject } from '../_types/ewpolicy';
import Policies from '../common/Policy/Policies';
import { useHistory, useParams } from 'react-router-dom';
import { IMemberSummary } from '../_types/member';
import { GetMemberSummaryDetailed } from '../_service/member';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Memberships from '../common/Memberships/Memberships';
import MemberSummary from '../common/Memberships/Member';

interface Props {

};


const Member: React.FC<Props> = (prop: Props) => {
    const { user } = useContext(AuthContext);

    const [editUser, setEditUser] = useState<IMemberSummary | null>(null);

    const [selection, setSelection] = useState<ISearchResult | null>(null);

    let { id } = useParams<any>();

    let history = useHistory();

    React.useEffect(() => {

        setEditUser(null);
        setSelection(null);

    }, [user])

    React.useEffect(() => {

    
        let pass_id = parseInt(id);
        GetMemberSummaryDetailed(pass_id).then(r => {
            
            setEditUser(r);

        });

    
    },[]);


    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
        root: {
            width: '100%',
            marginTop: 10
            },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular as number,
            },
        spinner: {
            marginLeft: 5,
            color: 'primary',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        header: {
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1)
        }
        }),
    );
    const classes = useStyles();


    const _changePolicy = (c: IObjectPolicy) => {
       
    }

    const _dashBoardUrl = (): string => {
        let toReturn = process.env.REACT_APP_LEGACY_DASHBOARD_URL;
        if (!toReturn) {
            toReturn = "/";
        }
        return `${toReturn}/#user/${editUser?.id!}`;
    }

    const [expandMemberships, setExpandMemberships] = useState<boolean>(true);

    return (
        <React.Fragment>
        {editUser && (
        <Grid container direction="column" justify="flex-start" alignItems="stretch">
            <Grid item>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                    <Grid  item>
                        <Typography variant="h6" className={classes.header}>{editUser.displayName}</Typography>
                    </Grid>
                    <Grid  item>
                        {editUser.uuid}
                    </Grid>
                    {editUser.email && editUser.email.length > 0 && (
                        <Grid  item>
                            {editUser.email}
                        </Grid>
                    )}
                    {editUser.phone && editUser.phone.length > 0 && (
                        <Grid  item>
                            {editUser.phone}
                        </Grid>
                    )}
                </Grid>
            </Grid>

            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                    <Grid  item>
                        <Button onClick={(e) => { history.push('/members/home') }} variant="outlined" color="primary">Close</Button>
                    </Grid>
                    <Grid  item>
                        <Button onClick={(e) => { window.location.href=_dashBoardUrl() }} variant="outlined" color="primary">Open in Dashboard</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        
        )}
        {editUser && (
            <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
                >
                <Typography className={classes.heading}>Member Summary</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <MemberSummary member={editUser}/>
                </AccordionDetails>
            </Accordion>
            {editUser.memberships && editUser.memberships.length > 0 ? (
            <Accordion expanded={expandMemberships} onChange={n => setExpandMemberships(!expandMemberships)}>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography className={classes.heading}>Memberships</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Memberships member={editUser}/>
                </AccordionDetails>
            </Accordion>
            ): <div style={{marginTop:10, marginBottom:10}}>No Memberships found.</div>}
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                <Typography className={classes.heading}>Security</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <UserCredentials policyObject={editUser as IPolicyObject}/>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography className={classes.heading}>Policy</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <Policies policyObject={editUser as IPolicyObject} onChange={_changePolicy}></Policies>
                </AccordionDetails>
            </Accordion>
            
            </div>
        )}
        </React.Fragment>
    )

}

export default Member;